import { Card } from "@/src/components/shad/card";
import clsx from "clsx";
import { FC } from "react";
import CountUp from "react-countup";
import { textVariants } from "@/src/components/Text/Text";
import { cn } from "@/lib/utils";
import { formatNumber } from "@/src/utils";
import { useTranslation } from "react-i18next";

interface Props {
  data: Rate[] | undefined;
}

const Balances: FC<Props> = ({ data: coin }) => {
  const { t } = useTranslation();
  const trans = (key: string) => t(`app.home.balances.table.${key}`);
  const coins = coin?.filter((item) => item.ticker !== "trx");
  if (!coins) return null;
  return (
    <div>
      <div className="hidden md:grid grid-cols-2 lg:grid-cols-3 gap-3">
        {coins?.map((item, index) => (
          <Card key={index} className="p-2 flex">
            <div className="grid gap-3 w-full">
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-2">
                  <div>
                    <img
                      src={item?.image}
                      alt={item?.ticker}
                      className="h-6 w-6"
                    />
                  </div>
                  <div className="grid">
                    <span className={cn(textVariants(), "uppercase")}>
                      {item?.ticker}
                    </span>
                    <span
                      className={textVariants({ size: "xs", variant: "desc" })}
                    >
                      {item?.label}
                    </span>
                  </div>
                </div>
                <span
                  className={clsx(
                    !item?.price_change_percentage_24h.includes("-")
                      ? "text-green-500"
                      : "text-red-500",
                    "text-sm"
                  )}
                >
                  {Number(item?.price_change_percentage_24h).toFixed(2)} %
                </span>
              </div>

              <div className="grid">
                <span className={textVariants({ size: "xl", variant: "desc" })}>
                  $
                  <CountUp
                    start={0}
                    duration={1.5}
                    decimal="."
                    decimals={2}
                    end={item?.current_price}
                  />
                </span>
              </div>
            </div>
            <div></div>
          </Card>
        ))}
      </div>
      <div className="grid md:hidden ">
        <div className="grid grid-cols-3">
          <span className={cn(textVariants({ size: "xs", variant: "desc" }))}>
            {trans("headers.name")}
          </span>
          <span
            className={cn(
              textVariants({ size: "xs", variant: "desc" }),
              "text-end"
            )}
          >
            {trans("headers.lastPrice")}
          </span>
          <span
            className={cn(
              textVariants({ size: "xs", variant: "desc" }),
              "text-end"
            )}
          >
            {trans("headers.24hChange")}
          </span>
        </div>
        <div className="grid gap-3 mt-2">
          {coins.map((item, index) => (
            <div key={index} className="grid grid-cols-3">
              <div className="flex gap-2 items-center">
                <div>
                  <img
                    src={item?.image}
                    alt={item?.ticker}
                    className="h-8 w-8"
                  />
                </div>
                <div className="flex flex-col">
                  <span className={cn(textVariants(), "uppercase")}>
                    {item?.ticker}
                  </span>
                  <span
                    className={cn(
                      textVariants({ size: "xs", variant: "desc" }),
                      "-mt-1"
                    )}
                  >
                    {item?.label}
                  </span>
                </div>
              </div>
              <div className="grid text-end">
                <span
                  className={textVariants({ size: "sm", font: "semibold" })}
                >
                  ${item?.current_price}
                </span>
                <span
                  className={cn(
                    textVariants({ size: "xs", variant: "desc" }),
                    "-mt-1"
                  )}
                >
                  ${item?.last_price}
                </span>
              </div>
              <div className="flex items-center justify-end">
                <span
                  className={cn(
                    "text-sm text-white w-16 text-center py-1.5 rounded",
                    item?.price_change_percentage_24h.includes("-")
                      ? "bg-red-400"
                      : "bg-green-600"
                  )}
                >
                  {formatNumber(item?.price_change_percentage_24h)}%
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Balances;
